export default __webpack_public_path__ + "static/media/activity-loading.dec34638.svg";